export const CONTEXT_TITLE = [
  {
    id: 0,
    name: '導入後推移'
  },
  {
    id: 1,
    name: '設定別'
  },
  {
    id: 2,
    name: '期間別'
  },
  {
    id: 3,
    name: '地区別'
  },
  {
    id: 4,
    name: '損益分岐割数別'
  },
  {
    id: 5,
    name: 'ランク別'
  },
];

export default CONTEXT_TITLE;
